export interface EntityType {
  id: string;
  name: string;
}

export const ENTITY_TYPES: EntityType[] = [
  { id: 'location', name: 'Location' },
  { id: 'person', name: 'Person' },
  { id: 'organization', name: 'Organization' },
  { id: 'time', name: 'Time' },
  { id: 'date', name: 'Date' },
  { id: 'percent', name: 'Percent' },
  { id: 'money', name: 'Money' },
  { id: 'commercial_item', name: 'Commercial Item' },
  { id: 'event', name: 'Event' },
  { id: 'title', name: 'Title' },
  { id: 'misc', name: 'Misc' },
  { id: 'social security number', name: 'Social Security Number' },
  { id: 'credit card', name: 'Credit Card' },
  { id: 'email address', name: 'Email Address' },
  { id: 'phone', name: 'Phone Number' },
].sort((a, b) => a.name.localeCompare(b.name));
